import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import wfhBackground from '../../../assets/wfh.svg';
import wfhDarkBackground from '../../../assets/wfh-dark.svg';
import DayUserBookings from '../../Spaces/dayUserBookings';
import { Box, Divider } from '@mui/material';
import useMediaQuery from '@material-ui/core/useMediaQuery';
const useStyles = makeStyles((theme) => ({
   root: {
      flexGrow: 1,
      justifyContent: 'center',
   },
}));

const WfhBlock = (props) => {
   const [location, setLocation] = useState(false);
   useEffect(() => {
      if (props.displayFilter) {
         let lid = props.displayFilter.id;
         if (props.displayFilter.type === 'group') {
            lid = props.displayFilter.lid;
         }
         setLocation({ id: lid, lid });
      }
   }, [props.displayFilter]);
   const classes = useStyles();
   const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
   return (
      <div className={classes.root}>
         <Box
            sx={{
               width: '100%',
               height: '70vh',
               display: 'flex',
               justifyContent: 'center',
               alignItems: 'start',
               mt: 1,
               backgroundImage: `url(${
                  prefersDarkMode ? wfhDarkBackground : wfhBackground
               })`,
               // backgroundSize: 'cover',
               backgroundRepeat: 'no-repeat',
               backgroundPosition: 'center',
            }}
         >
            {props.includeBookings && (
               <DayUserBookings
                  date={props.date}
                  user={props.user}
                  // dayTime={props.dayTime}
                  location={location}
                  hideIfEmpty={true}
               />
            )}

            {/* <img src={prefersDarkMode ? wfhDarkBackground : wfhBackground} alt="WFH" /> */}
         </Box>
      </div>
   );
};

export default WfhBlock;
